import { authHttp } from '../http'
import * as routes from '../../routes/system.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveMissingReasonStandard({
  id,
  sigla,
  descricao,
  type,
  visible_picking,
  visible_delivery,
  actived,
  devolucao_fisica,
}) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlMissingReasonStandard, {
        id,
        sigla,
        descricao,
        type,
        visible_picking,
        visible_delivery,
        actived,
        devolucao_fisica,
      })
    } else {
      response = await authHttp().post(routes.urlMissingReasonStandard, {
        sigla,
        descricao,
        type,
        visible_picking,
        visible_delivery,
        actived,
        devolucao_fisica,
      })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getMissingReasonStandard() {
  try {
    const response = await authHttp().get(routes.urlMissingReasonStandard)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
